<template>
  <div
    :class="{
      [$style.ToggleSwitch]: true,
      [$style[`ToggleSwitch--check`]]: value,
      [$style[`ToggleSwitch--uncheck`]]: !value,
    }"
    @click="handleChange"
  >
    <button :class="$style.ToggleSwitch__Btn" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  emits: ['onChange'],
  props: {
    value: Boolean,
  },
  setup() {
    return {}
  },
  methods: {
    handleChange() {
      this.$emit('onChange', !this.value);
    },
  },
})
</script>

<style lang="less" module>
.ToggleSwitch {
  display: flex;
  padding: 1px;
  width: 36px;
  height: 20px;
  background-color: var(--ToggleSwitch-background);
  border-radius: 10px;
  box-sizing: border-box;
  justify-content: var(--ToggleSwitch-justify);
  cursor: pointer;

  &--check {
    --ToggleSwitch-background: #13C2C2;
    --ToggleSwitch-justify: flex-end;
  }
  &--uncheck {
    --ToggleSwitch-background: var(--TradeSetting-switch-background);
    --ToggleSwitch-justify: flex-start;
  }

  &__Btn {
    width: 18px;
    height: 18px;
    border-radius: 9px;
    border: 0 none;
    cursor: pointer;
    background-color: #fff;
  }
}
</style>
